import { render } from "./Dashboard-EIS-PTJ.vue?vue&type=template&id=4e6fd286"
import script from "./Dashboard-EIS-PTJ.vue?vue&type=script&lang=js"
export * from "./Dashboard-EIS-PTJ.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__